import React, {Component} from 'react';
import {injectIntl} from 'react-intl';

class ProjectTotalHeaderItem extends Component {
	render() {
		let firstLine;
		let secondLine;
		if (this.props.multiLine && this.props.label) {
			const nameArr = this.props.label.split(' ');
			firstLine = nameArr[0];
			secondLine = nameArr[1];
		}
		return (
			<div className={'project-total-header-item' + (this.props.itemType ? this.props.itemType : '')} style={{textAlign: this.props.textAlign}} data-cy={this.props.cy} title={this.props.title}>
				{!this.props.label ? null : this.props.multiLine ? (
					<div className={'multi-line-header'}>
						<div className={'text line-1'} style={{textAlign: this.props.textAlign}}>
							{firstLine}
						</div>
						<div className={'text line-2'} style={{textAlign: this.props.textAlign}}>
							{secondLine}
						</div>
					</div>
				) : (
					<div className="text" style={{textAlign: this.props.textAlign}}>
						{this.props.label}
					</div>
				)}

				{this.props.projectTotalExpanded ? (
					<div className={'value' + (this.props.shouldAnimate ? ' animated fadeIn faster' : '')} style={{textAlign: this.props.textAlign}} data-cy={this.props.cy + '-value'}>
						{this.props.value}
					</div>
				) : null}
			</div>
		);
	}
}

ProjectTotalHeaderItem.propTypes = {};

export default injectIntl(ProjectTotalHeaderItem);
